"use client"

import { usePageTracking } from "@/hooks/use-analytics"

export function TrackMainPage() {
  usePageTracking("login")
  return null
}
